export const BRAND_CONFIG = {
  productName: 'lugsail',
  wordmark: {
    lead: 'lug',
    accent: 'sail',
  },
  tagline:
    'A client-side chart workflow for auditing data, styling charts, and exporting clean outputs.',
  repositoryUrl: 'https://github.com/lugsails/rawgraphs-app',
  issuesUrl: 'https://github.com/lugsails/rawgraphs-app/issues',
  docsUrl: 'https://github.com/lugsails/rawgraphs-app',
  privacyUrl: 'https://github.com/lugsails/rawgraphs-app',
  support: {
    emailSubject: 'Visit lugsail',
    emailBody:
      'Hello!\r\nRemember to come back to lugsail on a larger screen for the full charting workflow.\r\n',
  },
  assets: {
    iconPath: '/lugsail-mark.svg',
  },
  ui: {
    accentColor: '#E8692A',
  },
  storage: {
    themeKey: 'lugsail-theme',
    profileKey: 'lugsail-brand-profiles',
    sessionKey: 'lugsail-session',
  },
  fonts: {
    default: 'inter',
    options: [
      { id: 'inter', label: 'Inter', value: "'Inter', sans-serif" },
      { id: 'plex-mono', label: 'IBM Plex Mono', value: "'IBM Plex Mono', monospace" },
      { id: 'arial-narrow', label: 'Arial Narrow', value: "'Arial Narrow', Arial, sans-serif" },
      { id: 'helvetica', label: 'Helvetica', value: 'Helvetica, Arial, sans-serif' },
      { id: 'arial', label: 'Arial', value: 'Arial, sans-serif' },
      { id: 'georgia', label: 'Georgia', value: 'Georgia, serif' },
      { id: 'times', label: 'Times New Roman', value: "'Times New Roman', serif" },
    ],
  },
  theme: {
    primaryColor: '#1f77b4',
    secondaryColor: '#ff7f0e',
    backgroundColor: '#ffffff',
    textColor: '#181818',
    labelColor: '#181818',
    markOpacity: 1,
    lineStrokeScale: 1,
    fontFamily: "'Inter', sans-serif",
    labelHandlingMode: 'auto',
    labelOverflowStrategy: 'angled',
    labelFontScale: 1,
    labelOutline: false,
    labelShowEveryNth: 1,
    labelShowFullOnHover: true,
    labelMaxCharacters: 12,
    title: '',
    subtitle: '',
    palette: null,
  },
  footer: {
    body:
      'lugsail is a client-side chart workflow for auditing messy tabular data, choosing a chart, applying a light brand theme, and exporting clean outputs.',
    contact:{
      email: "hello@andjam.es"
    }
    },
}

export function getReminderMailtoHref() {
  return `mailto:?subject=${encodeURIComponent(
    BRAND_CONFIG.support.emailSubject
  )}&body=${encodeURIComponent(BRAND_CONFIG.support.emailBody)}`
}

export function getBrandFontOptions() {
  return BRAND_CONFIG.fonts.options
}

export function getBrandFontByValue(value) {
  return BRAND_CONFIG.fonts.options.find((option) => option.value === value) || null
}

export function getBrandFontOptionMatchingName(name) {
  if (typeof name !== 'string' || !name.trim()) return null
  const normalized = name.trim().toLowerCase()
  return (
    BRAND_CONFIG.fonts.options.find((option) => option.label.toLowerCase() === normalized) ||
    BRAND_CONFIG.fonts.options.find((option) => option.label.toLowerCase().includes(normalized)) ||
    null
  )
}

export function applyDocumentBranding() {
  document.title = BRAND_CONFIG.productName

  const rootStyle = document.documentElement.style
  const accentColor = BRAND_CONFIG.ui.accentColor
  const accentRgb = hexToRgbString(accentColor)
  if (accentRgb) {
    rootStyle.setProperty('--primary', accentColor)
    rootStyle.setProperty('--primary-rgb', accentRgb)
  }

  const metaDescription = document.querySelector('meta[name="description"]')
  if (metaDescription) {
    metaDescription.setAttribute('content', BRAND_CONFIG.tagline)
  }

  const themeColor = document.querySelector('meta[name="theme-color"]')
  if (themeColor) {
    themeColor.setAttribute('content', BRAND_CONFIG.theme.primaryColor)
  }

  const iconHref = BRAND_CONFIG.assets.iconPath
  const favicon = document.querySelector('link[rel="icon"]')
  if (favicon) {
    favicon.setAttribute('href', iconHref)
  }

  const appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]')
  if (appleTouchIcon) {
    appleTouchIcon.setAttribute('href', iconHref)
  }
}

function hexToRgbString(hex) {
  if (typeof hex !== 'string') return null
  const normalized = hex.trim().replace('#', '')
  if (!/^[0-9a-f]{6}$/i.test(normalized)) return null

  const int = Number.parseInt(normalized, 16)
  const r = (int >> 16) & 255
  const g = (int >> 8) & 255
  const b = int & 255
  return `${r}, ${g}, ${b}`
}
